import { render, staticRenderFns } from "./DataColumn.vue?vue&type=template&id=a1d8a2ee&"
import script from "./DataColumn.vue?vue&type=script&lang=js&"
export * from "./DataColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports